/** @jsx jsx */
import { jsx } from '@emotion/react';

import { useLocation } from 'js/lib';

import SkillPageRootContent from 'bundles/browse-common/components/SkillPageRootContent';
import SkillPageProvider from 'bundles/browse-common/providers/SkillPageProvider';
import OnboardingV3Provider from 'bundles/onboarding-common/providers/OnboardingV3Provider';
import EntityPageCanonicalTagWrapper from 'bundles/seo-entity-page/components/EntityPageCanonicalTagWrapper';

type Props = {
  skillSlug: string;
};

const SkillPage = (props: Props) => {
  const { skillSlug } = props;

  const { query, pathname } = useLocation();

  return (
    <SkillPageProvider skillSlug={skillSlug}>
      <OnboardingV3Provider>
        <EntityPageCanonicalTagWrapper query={query} pathname={pathname} />
        <SkillPageRootContent />
      </OnboardingV3Provider>
    </SkillPageProvider>
  );
};

export default SkillPage;
